import i18n from 'l10n';
import _ from 'underscore';
import GenericView from 'js/views/generic.view';
import GroupModel from 'js/models/group.model';
import GroupsTilesView from 'js/views/groups.tiles.view';
import EngagementTemplate from 'js/templates/metrics.groups.tiles.hbs';
import dhtmlx from 'dhtmlxAdapter';
import {el, on, tagName} from "../adapters/backbone-decorators";

require('js/models/groups.collection');
require('metroHelpers');

@el('.container')
@tagName('span')
class EngagementView extends GenericView {

    constructor() {
        super();
        this.groupsView = new GroupsTilesView({
            "el": "#engagementMetricGroups",
            "customTemplate": EngagementTemplate,
            "queryGroupsOnly": true
        });
        this.groupsView.groupsCollection.fetch().done(() => {
            this.groupsView.groupsCollection.models = _.filter(this.groupsView.groupsCollection.models, model => {
                if (model.get("groupType") === "query" && model.get("query").indexOf("engagementMetric") !== -1) {
                    model.set("isEngagementGroup", true);
                    return true;
                }
            });
        }).fail((model, status) => {
            $.Notify.error(`${i18n.t("subscriber.nocontactsstatus")} = ${status.status}`);
        });

        // engagement Group Bounds Slider
        const $slider = $("#slider-range");
        $slider.slider({
            range: true,
            min: 0,
            max: 100,
            values: [50, 60],
            slide(event, ui) {
                var sliderValues = $slider.slider("option", "values");
                $("#engagementMinValue").text(ui.values[0]);
                $("#engagementMaxValue").text(ui.values[1]);
            }
        });

        //Show initial values
        var sliderValues = $slider.slider("option", "values");
        $("#engagementMinValue").text(sliderValues[0]);
        $("#engagementMaxValue").text(sliderValues[1]);
    }

    render() {
        super.render();
    }

    @on('click #createEngagementGroup')
    async newEngagementGroup() {
        var minValue = parseInt($("#engagementMinValue").text());
        var maxValue = parseInt($("#engagementMaxValue").text());

        if (this.hasInvalidInputs(minValue, maxValue)) {
            //do not create the group, if there are invalid input values
            return;
        }

        var model = new GroupModel({
            url() {
                return model.urlRoot;
            }
        });
        var groupTitle = i18n.t("engagement.newEngagementGroupName", {from: minValue, to: maxValue});
        var query = `in engagementMetricBetween(${minValue / 100}, ${maxValue / 100})`;

        model.set("title", groupTitle);
        model.set("groupType", "query");
        model.set("query", query);
        model.url = function () {
            return model.urlRoot;
        };
        model.isNew = function () {
            return true;
        };

        try {
            const result = await dhtmlx.confirm({
                type: "confirm",
                text: i18n.t("satisfaction.createSatisfactionGroupBetween", {"min": minValue, "max": maxValue}),
                ok: i18n.t("message.yes"),
                cancel: i18n.t("message.no")
            });

            if (result) {
                const responseModel = await model.save(model.attributes);
                if (responseModel) {
                    const theModel = new GroupModel(responseModel.attributes);
                    this.groupsView.groupsCollection.add(theModel);
                    // var self = self.groupsView;
                    //used from another views, e.g. satisfaction.view, after creating a new group.
                    //pass the newly created model, get its appropriate data and render it.
                    this.groupsView.getAndUpdateGroupsCounters(responseModel);
                    $.Notify.show(i18n.t("instantWin.groupCreatedSuccessfully"));
                } else {
                    $.Notify.error(i18n.t("instantWin.errorCreatingGroup") + ". Outcome: " + responseModel);
                }
            }
        } catch (e) {
            console.info(e);
            $.Notify.error(i18n.t("instantWin.errorCreatingGroup"));
        }
    }

    hasInvalidInputs(minValue, maxValue) {
        if (minValue >= maxValue) {
            dhtmlx.alert(i18n.t("engagement.checkEngagementBoundaries"));
            return true;
        } else if (minValue.length === 0 || maxValue.length === 0) {
            dhtmlx.alert(i18n.t("engagement.fieldMustNotBeEmpty"));
            return true;
        } else if (isNaN(minValue) || isNaN(maxValue)) {
            dhtmlx.alert(i18n.t("engagement.useNumbersAlert"));
            return true;
        }

        return false;
    }
}

export default EngagementView;
